import React from "react";
import "../AssessmentCriteria/ACMarksSidePanel.css";
import {useConsortiaCenter} from "../../context/ConsortiaCenterContext";
import { useCenter } from "../../context/CenterContext";
import { useSubject } from "../../context/SubjectContext";
import { useLocation } from "react-router-dom";
import { getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";

const ACUpdateMarksSidePanel = ({
  assessmentCandidateData = [],
  candidateDataMap = {},
  setSelectedCandidate,
  mode,
  currentSection,
  onOriginalMarksClick,
  onUpdatedMarksClick,
  selectedCandidate,
  updatedCriteriaAchievedCount,
  updatedTotalCriteriaScore,
  safeCandidates
}) => {
  
   // removes undefined/null .map((val) => ({
  const candidates = (assessmentCandidateData || []) .filter(Boolean).map((val) => ({
    candidateName: val.candidateName,
    candidateId: val.centreCandidateNumber ?? val.candidateNumber ?? "",
    centreNumber: val.centreNumber,
    centreCandidateSampleId: val.centreCandidateSampleId,
  }));
     const location = useLocation();
      const { unit, sessionId } = location.state || {};
        const { centerNumber } = useCenter();
        const {subjectData} = useSubject();
        const {consortiaCentres = []} = useConsortiaCenter();
      
        const currentCentreType = getCenterType(consortiaCentres, Number(centerNumber), subjectData?.selectedSubject, subjectData?.selectedSubjectId) || '';
 const consortiaUnitcode =
      String(unit ?? "")
        .toUpperCase()
        .match(/^[A-Z0-9]+/)?.[0] || "";
    const isConsortiaUnit = checkunitIsConsortiaUnit(
        consortiaCentres,
        centerNumber,
        sessionId,
        consortiaUnitcode,
      );
  
  const onClickOriginalCandidate = (candidate, event) => {
    onOriginalMarksClick();

    const link = event.currentTarget.querySelector("a");
    if (link) {
      link.focus();
      setTimeout(() => link.blur(), 1000);
    }

    setSelectedCandidate(candidate.candidateId, 'originalMarks');
  };

  const onClickUpdatedCandidate = (candidate, event) => {
    // Switch to updated marks section
    onUpdatedMarksClick();

    const link = event.currentTarget.querySelector("a");
    if (link) {
      link.focus();
      setTimeout(() => link.blur(), 1000);
    }

    setSelectedCandidate(candidate.candidateId, 'updatedMarks');
  };

  const isGreen = (candidateId) => {
    const entry = candidateDataMap[candidateId];
    if (!entry) return false;

    const { achievedCount, candidateMarks } = entry;
    if (achievedCount == null || candidateMarks == null) return false;
    
    return achievedCount === candidateMarks;
  };
  const isUpdatedGreen = (candidateId) => { 
    const yesCount = updatedCriteriaAchievedCount[candidateId]; 
    const candidate = safeCandidates.find( (c) => String(c.centreCandidateNumber) === String(candidateId) );
     if (!candidate) return false; 
     const total =
      updatedTotalCriteriaScore[candidateId] 
     return yesCount === total; 
    };
    


    
  if (!Array.isArray(assessmentCandidateData)) { return null; }
  return (
    <aside className="candidate-menu xis-hidden">
      <div
        id="pnlSideMenuNav"
        style={{
          overflow: "auto",
          height: "calc(100% - 77px)",
          paddingBottom: "4em",
        }}
      >
        <table className="table is-hoverable is-fullwidth" id="tblUnitListTable">
          <thead>
            <tr>
              <th>Sample candidates</th>
            </tr>
          </thead>

          {/* 1. Original marks */}
          <tbody>
            <tr className="row-header">
              <td>
                <strong>1. Original marks</strong>
              </td>
            </tr>

            {candidates.map((candidate) => {
  const green = isGreen(candidate.candidateId);
   let currentCandidate = safeCandidates.find(
                (val) => val.centreCandidateNumber == candidate.candidateId
              );
     let isAllOriginalCriteriaFilled =
                currentCandidate && Array.isArray(currentCandidate.criteriaOriginal)
                  ? currentCandidate.criteriaOriginal.every((item) => item.originalCentreAssessmentName && String(item.originalCentreAssessmentName).trim() !== "")
                  : false;

              return (
                <tr
                  key={`original-${candidate.candidateId}`}
                  onClick={(e) => onClickOriginalCandidate(candidate, e)}
                >
                  <td className="candidate-cell">
                    <a
                      tabIndex={0}
                      className={`candidate-list-item ${
                        selectedCandidate === candidate.candidateId &&
                        currentSection === "originalMarks"
                          ? "is-active"
                          : ""
                      }`}
                    >
                      <span className="candidate-status">
                        <span className="icon">
                          {(green && isAllOriginalCriteriaFilled )? (
                            <svg
                              aria-hidden="true"
                              focusable="false"
                              style={{ fill: "#2B8000" }}
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z" />
                            </svg>
                          ) : (
                            <svg
                              style={{ fill: "#f14668" }}
                              focusable="false"
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.00137 20.0099C2.46137 20.0099 1.50137 18.3399 2.27137 17.0099L9.80137 3.99994C10.5714 2.66994 12.4914 2.66994 13.2614 3.99994L20.7914 17.0099C21.5614 18.3399 20.6014 20.0099 19.0614 20.0099H4.00137ZM19.0614 18.0099L11.5314 4.99994L4.00137 18.0099H19.0614Z"
                              />
                              <path d="M10.5312 10.01V13C10.5312 13.55 10.9812 14 11.5312 14C12.0812 14 12.5312 13.55 12.5312 13V10.01C12.5312 9.46001 12.0812 9.01001 11.5312 9.01001C10.9812 9.01001 10.5312 9.46001 10.5312 10.01Z" />
                              <circle cx="11.5312" cy="16.01" r="1" />
                            </svg>
                          )}
                        </span>
                      </span>
                      <div className="candidate-info">
                        {((currentCentreType === "Lead" && isConsortiaUnit) || (currentCentreType === 'Rest' && mode ==='view' && isConsortiaUnit) )&& <span  style={{fontSize:"13px", fontWeight:"500", }}> CENTRE:{candidate.centreNumber}</span>}

                        <span className="candidate-name">{candidate.candidateName}</span>
                        <span className="candidate-number">{candidate.candidateId}</span>
                      </div>
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>

          <tbody>
            <tr className="row-divider">
              <td style={{ padding: 0 }}>
                <hr style={{ border: "0", height: "1px", margin: "10px 0" }} />
              </td>
            </tr>
          </tbody>

          {/* 2. Updated marks */}
          <tbody>
            <tr className="row-header">
              <td>
                <strong>2. Updated marks</strong>
              </td>
            </tr>

            {candidates.map((candidate) => {
const green = isUpdatedGreen(candidate.candidateId);
  let currentCandidate = safeCandidates.find(
                (val) => val.centreCandidateNumber == candidate.candidateId
              );
              let isAllUpdatedCriteriaFilled =
                currentCandidate && Array.isArray(currentCandidate.criteriaUpdated)
                  ? currentCandidate.criteriaUpdated.every((item) => item.updatedCentreAssessmentName && String(item.updatedCentreAssessmentName).trim() !== "")
                  : false;

                  

            return (

            
              <tr
                key={`updated-${candidate.candidateId}`}
                onClick={(e) => onClickUpdatedCandidate(candidate, e)}
              >
                <td className="candidate-cell">
                  <a
                    tabIndex={0}
                    className={`candidate-list-item ${
                      selectedCandidate === candidate.candidateId &&
                      currentSection === "updatedMarks"
                        ? "is-active"
                        : ""
                    }`}
                  >
                    <span className="candidate-status">
                      <span className="icon">
                       {(green &&isAllUpdatedCriteriaFilled) ? (
                            <svg
                              aria-hidden="true"
                              focusable="false"
                              style={{ fill: "#2B8000" }}
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z" />
                            </svg>
                          ) : (
                            <svg
                              style={{ fill: "#f14668" }}
                              focusable="false"
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.00137 20.0099C2.46137 20.0099 1.50137 18.3399 2.27137 17.0099L9.80137 3.99994C10.5714 2.66994 12.4914 2.66994 13.2614 3.99994L20.7914 17.0099C21.5614 18.3399 20.6014 20.0099 19.0614 20.0099H4.00137ZM19.0614 18.0099L11.5314 4.99994L4.00137 18.0099H19.0614Z"
                              />
                              <path d="M10.5312 10.01V13C10.5312 13.55 10.9812 14 11.5312 14C12.0812 14 12.5312 13.55 12.5312 13V10.01C12.5312 9.46001 12.0812 9.01001 11.5312 9.01001C10.9812 9.01001 10.5312 9.46001 10.5312 10.01Z" />
                              <circle cx="11.5312" cy="16.01" r="1" />
                            </svg>
                          )}
                      </span>
                    </span>

                    <div className="candidate-info">
                        {((currentCentreType === "Lead" && isConsortiaUnit) || (currentCentreType === 'Rest' && mode ==='view' && isConsortiaUnit) )&& <span  style={{fontSize:"13px", fontWeight:"500", }}> CENTRE:{candidate.centreNumber}</span>}

                      <span className="candidate-name">{candidate.candidateName}</span>
                      <span className="candidate-number">{candidate.candidateId}</span>
                    </div>
                  </a>
                </td>
              </tr>
            )
})}
          </tbody>
        </table>
      </div>
    </aside>
  );
};

export default ACUpdateMarksSidePanel;
